<!-- ngView: -->
<div id="contents" role="main" data-ng-view="" class="ng-scope" >
	<div class="progress ng-scope">
		<ul>
			<li class="active"><i class="sp ico_progress1"></i><span class="ng-binding">SELECT PRODUCT</span></li>
			<li><i class="sp ico_progress2"></i><span class="ng-binding">INPUT PERSONAL INFORMATION</span></li>
			<li><i class="sp ico_progress3"></i><span class="ng-binding">MAKE PAYMENT</span></li>
			<li><i class="sp ico_progress4"></i><span class="ng-binding">COMPLETE PAYMENT</span></li>
		</ul>
	</div>
<div class="container">
	<section class="flex_ctr_bx sec_agreement ng-scope">
		<div class="sub-title"><h3>Select Product</h3>
			<p>Acceptance of Samsung's Privacy Policy, and Terms and Conditions is required to purchase Samsung Care+</p></div>
		
		<div class="heading">
			<div class="terms-img"><img src="./assets/images/policy-img.jpg"></div>
			<div class="terms-box">
			<p class="txt tit_txt ng-binding" data-ng-bind-html="'text.tnc.01' | translate | htmlSafe">By purchasing Samsung
				Care+, I acknowledge that I have read and agree to Samsung's Privacy Policy, and Terms and Conditions. I
				authorize Samsung to charge the cost of Samsung Care+ to the selected payment method.<br><br>Get peace of mind
				with this service contract program which includes; coverage for Repair or Replacement for covered breakdowns
				including power surge for your TV.
			</p>
			<ul class="txt">
				<!-- ngIf: ('text.tnc.02' | translate) != '' -->
				<!-- ngIf: ('text.tnc.03' | translate) != '' -->
			</ul>
			<div class="form_wrap">
				<span class="input_chk_basic">
					<input type="checkbox" name="agrt" id="agrt0" [(ngModel)]="isConfirmed[0]">
					<label for="agrt0">
						<span class="blind">Read and agree0</span>
					</label>
					<span class="txt_label">
						<a href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/" target="_blank"
							class="link">Terms and Conditions</a>
					</span>
				</span>
				<span class="input_chk_basic">
					<input type="checkbox" name="agrt" id="agrt1" [(ngModel)]="isConfirmed[1]">
					<label for="agrt1">
						<span class="blind">Read and agree1</span>
					</label>
					<span class="txt_label">
						<a href="https://www.samsung.com/us/account/privacy-policy/" target="_blank" class="link">Privacy Policy</a>
					</span>
				</span>
			</div>
		</div>
		</div>
	
		<!--
		<div class="form_wrap">
			<span class="input_chk_basic ng-scope" data-ng-repeat="x in vm.list">
				<input type="checkbox" name="agrt" id="agrt0" data-ng-model="x.selected" data-ng-change="on.toggleCheckbox()"
					class="ng-pristine ng-untouched ng-valid ng-empty">
				<label for="agrt0">
					<span class="blind ng-binding">Read and agree0</span>
				</label>
				<span class="txt_label ng-binding" data-ng-bind-html="x.text | htmlSafe">
					<a href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/" target="_blank"
						class="link">Terms and Conditions</a></span>
			</span>
			<span class="input_chk_basic ng-scope" data-ng-repeat="x in vm.list">
				<input type="checkbox" name="agrt" id="agrt1" data-ng-model="x.selected" data-ng-change="on.toggleCheckbox()"
					class="ng-pristine ng-untouched ng-valid ng-empty">
				<label for="agrt1">
					<span class="blind ng-binding">Read and agree1</span>
				</label>
				<span class="txt_label ng-binding" data-ng-bind-html="x.text | htmlSafe">
					<a href="https://www.samsung.com/us/account/privacy-policy/" target="_blank" class="link">Privacy
						Policy</a></span>
			</span>
		</div>
		-->
		<!-- ngIf: ('display.tnc.checkAll' | translate) != 'false' -->
		<div class="btn_area">
			<a class="btn btn_type2" (click)="onPrevious()"><img src="./assets/images/button-arrow-pre.png">Previous</a>
			<a class="btn btn_type1" [ngClass]="{'disable': !(isConfirmed[0] && isConfirmed[1])}" (click)="onNext()">Agree and Continue<img src="./assets/images/button-arrow.png"></a>
		</div>
	</section>
</div>
</div>